import { useParams, Navigate, Link } from 'react-router-dom'
import { getDashboardById } from '../services/dashboardService'
import PowerBIEmbed from '../components/PowerBIEmbed'

export default function DashboardDetail() {
  const { id } = useParams<{ id: string }>()
  
  if (!id) {
    return <Navigate to="/404" replace />
  }

  const dashboard = getDashboardById(id)

  if (!dashboard) {
    return <Navigate to="/404" replace />
  }

  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-cbc-navy/40 via-transparent to-cbc-primary/5">
      <div className="bg-gradient-to-r from-cbc-navy/80 via-cbc-dark-blue/70 to-cbc-dark-blue/60 backdrop-blur-sm border-b border-cbc-medium-blue/15 px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <div className="min-w-0">
            <div className="flex items-center space-x-2 md:space-x-3">
              <Link
                to="/"
                className="p-1.5 rounded-lg text-cbc-light-blue/80 hover:text-cbc-paper hover:bg-cbc-light-blue/10 transition-all duration-200 flex-shrink-0"
                title="Volver al inicio"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
              </Link>
              <h1 className="text-lg md:text-2xl font-bold text-white truncate">
                {dashboard.name}
              </h1>
            </div>
            <p className="text-xs md:text-sm text-cbc-light-blue/75 mt-1 ml-8 truncate">
              {dashboard.description}
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 p-2 md:p-6">
        <PowerBIEmbed url={dashboard.url} title={dashboard.name} />
      </div>
    </div>
  )
}
